export default __webpack_public_path__ + "static/media/green-facebook.2199c77b.png";